import { render, staticRenderFns } from "./quick-reply-buttons.vue?vue&type=template&id=79e62b72&scoped=true&"
import script from "./quick-reply-buttons.vue?vue&type=script&lang=js&"
export * from "./quick-reply-buttons.vue?vue&type=script&lang=js&"
import style0 from "./quick-reply-buttons.vue?vue&type=style&index=0&id=79e62b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e62b72",
  null
  
)

export default component.exports